const toAttrs = (arr) =>
  (Array.isArray(arr) ? arr : []).reduce(
    (acc, attr) => (attr?.attribute_code != null ? { ...acc, [attr.attribute_code]: attr.value } : acc),
    {}
  );

export const transformWishlistProductFromAPI = (apiProduct) => {
  if (!apiProduct) return null;
  const attrs = toAttrs(apiProduct.custom_attributes);
  const img = attrs.image || attrs.small_image || attrs.thumbnail || '';
  const base = process.env.NEXT_PUBLIC_IMG_BASEURL || '';
  const orig = Number(apiProduct.price) || 0;
  const special = attrs.special_price ? parseFloat(attrs.special_price) : null;

  return {
    id: apiProduct.id,
    sku: apiProduct.sku,
    name: apiProduct.name ? [apiProduct.name] : [],
    rewrite_url: attrs.url_key || '',
    prices_with_tax: {
      original_price: orig,
      discounted_price: special != null && special < orig ? special : orig,
      discounted_price_from: attrs.special_from_date || '',
      discounted_price_to: attrs.special_to_date || '',
    },
    _media_: { image: img ? [{ image: `${base}/catalog/product${img}` }] : [] },
    label: [],
    stock: { is_in_stock: apiProduct.status === 1 },
  };
};

export const transformWishlistResponse = (apiResponse) => {
  const data = apiResponse?.data ?? apiResponse;
  const items = data?.items || [];
  const itemsBySku = {};

  for (const item of items) {
    const product = item?.product;
    if (!product?.sku) continue;
    const t = transformWishlistProductFromAPI(product);
    if (t) {
      t.wishlistItemId = item.id;
      itemsBySku[product.sku] = t;
    }
  }

  return {
    items: itemsBySku,
    itemsCount: data?.items_count ?? 0,
    sharingCode: data?.sharing_code,
    customerId: data?.customer_id,
  };
};
